import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["deliveryAddress"]

  connect() {
  }

  toggleDeliveryAddress(event) {
    if (event.currentTarget.checked) {
      this.deliveryAddressTarget.classList.add("hidden");
    } else {
      this.deliveryAddressTarget.classList.remove("hidden");
    }
  }
}
